import { createFileRoute } from '@tanstack/react-router'
import { AutomationMonitorsPage } from '@/features/monitoring/automation-monitors-page'

type AutomationMonitorsSearch = {
  instanceId?: number
}

export const Route = createFileRoute('/_authenticated/automation/monitors')({
  component: AutomationMonitorsPage,
  validateSearch: (search: Record<string, unknown>): AutomationMonitorsSearch => ({
    instanceId:
      search.instanceId !== undefined && search.instanceId !== null
        ? Number(search.instanceId)
        : undefined,
  }),
})
